<template>
  <div class="flex items-center gap-1">
    <!-- {{ properties }} -->
    <ToolBarOption
      v-for="(property, index) in properties"
      :key="`toolbar-prop-${index}`"
      :editor="editor"
      :config="config"
      :property-name="property"
      :inverse="inverse"
    />
  </div>
</template>

<script setup lang="ts">
import IEditorConfig from "../../types/IEditorConfig";
import { Editor } from "@tiptap/core";
import { computed } from "vue";
import ToolBarOption from "./ToolBarOption.vue";

const props = defineProps<{
  editor: Editor;
  config: IEditorConfig;
  propertiesString: string;
  inverse?: boolean;
}>();

const availableProperties = [
  "blocks",
  "fontfamily",
  "fontsizeinput",
  "bold",
  "italic",
  "underline",
  "strikethrough",
  "removeformat",
  "nonbreaking",
  "textAlign",
  "link",
  "numlist",
  "bullist",
  "forecolor",
  "backcolor",
  "mergefields",
  "emoticons",
  "code",
  "more",
];

const properties = computed(() => {
  let containAlign = false;
  let containMore = false;
  return props.propertiesString
    .split(" ")
    .map((prop) => {
      prop.trim();
      if (prop === "") return;
      if (
        prop === "alignleft" ||
        prop === "aligncenter" ||
        prop === "alignright" ||
        prop === "alignjustify"
      ) {
        if (containAlign) {
          return;
        } else {
          containAlign = true;
          return "textAlign";
        }
      }
      // TinyMCE keeps ltr/rtl inside its "more"/"more_button" overflow groups
      // and lists them as two separate items. Here all four tokens collapse
      // into the single "…" dropdown that holds the direction buttons, so a row
      // asking for any of them ends up with exactly one overflow button.
      if (
        prop === "more" ||
        prop === "more_button" ||
        prop === "ltr" ||
        prop === "rtl"
      ) {
        if (containMore) {
          return;
        } else {
          containMore = true;
          return "more";
        }
      }
      return prop;
    })
    .filter((prop) => {
      if (!prop) return false;
      if (prop && prop !== "") {
        return availableProperties.includes(prop);
      }
    });
});
</script>
